<template>
<div class="services">

  <JumboPanel
    class="services-header"
    header="Let us help you with that">
    <hr class="my-4">
    <p>
      Tall Oaks Environmental Research combines technology and database solutions with in-depth statistics and ecology research experience to solve data problems. Read below to learn more about the ACORNS application and additional services Tall Oaks provides.
    </p>

    <div
      class="jumbo-image"
      slot="image">
      <PuzzleIcon
        height="300"
        width="300"/>
    </div>

  </JumboPanel>


  <section id="services">

    <div
      v-for="s in servicesNewsProjects"
      :key="s.uid"
      :id="s.uid"
      class="services">
      <h3>
        <component
          v-if="s.icon"
          :is="s.icon"
          :width="48"
          :height="48"/>
        {{ s.label }}
      </h3>
      <hr/>
      <MarkdownDiv
        :text="s.details"/>
      <div
        v-if="s.projects.length || s.news.length"
        class="related-projects">
        <ul>
          <li
            v-for="p in s.projects"
            :key="p.uid">
            <router-link
              :to="`/projects/${p.uid}`">
              {{ p.label }}
            </router-link>
          </li>
          <li
            v-for="n in s.news"
            :key="n.uid">
            <router-link
              :to="`/stories/${n.uid}`">
              {{ n.label }}
            </router-link>
          </li>
        </ul>
      </div>

    </div>
  </section>

  <ContactPanel>
    <h3>Think we can help you?</h3>
    <p>
      If any of our services look like something you need just let us know.
    </p>
  </ContactPanel>

</div>
</template>

<script>
  import MarkdownDiv from '@/components/MarkdownDiv';
import InfoPanel from '@/components/sections/InfoPanel';
import LinkPanel from '@/components/sections/LinkPanel';
import CardPanel from '@/components/sections/CardPanel';
import JumboPanel from '@/components/sections/JumboPanel';
import ContactPanel from '@/components/sections/ContactPanel';
import PuzzleIcon from '../assets/img/puzzle1.svg'
import { mapState, mapActions, mapGetters } from 'vuex'
import ScrollIntoView from '@/mixins/ScrollIntoView';

export default {
  name: 'Services',
  mixins: [
    ScrollIntoView,
  ],
  components: {
    CardPanel,
    InfoPanel,
    JumboPanel,
    ContactPanel,
    LinkPanel,
    PuzzleIcon,
    MarkdownDiv,
  },
  created(){
    this.pageView('about');
  },
  computed: {
      ...mapState([
        'services',
        'problems',
        'messages',
        'projects',
        'articles',
        'links',
      ]),
    ...mapGetters([
      'activeNews',
      'activeProjects'
    ]),
    servicesNewsProjects(){
      return this.services
        .map( s => {
          // all the articles that are
          var news = this.activeNews
              .filter( n => n.tags.some( t => s.tags.includes(t)))
              .slice(0, 3)
              .map( n => ({ uid: n.uid, label: n.label }))
          var projects = this.activeProjects
              .filter( p => p.tags.some( t => s.tags.includes(t)))
              .slice(0, 3)
              .map( p => ({ uid: p.uid, label: p.label }))
          return { ...s, news, projects }
        })
    }
  },
  methods: {
    ...mapActions([
      'pageView'
    ]),
    url(file){
      return `url(/img/${file})`;
    }
  }
}
</script>


<style lang="scss" scoped>
@import '~@/styles/variables';
.services {

  .services-header {
    background-color: $color4 !important;
  }

  #services {
    margin: 0 auto;
    max-width: 70rem;
    padding: 0 2rem;
  }
}
</style>
